import { render, staticRenderFns } from "./equipment-violatrecord.vue?vue&type=template&id=0180d454&"
import script from "./equipment-violatrecord.vue?vue&type=script&lang=js&"
export * from "./equipment-violatrecord.vue?vue&type=script&lang=js&"
import style0 from "./equipment-violatrecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports